/* eslint-disable @next/next/no-img-element */
import { SRLWrapper } from 'simple-react-lightbox';
import classNames from 'classnames';
import { ContentDataBlockImage } from '@amf/shared/components/content/Content';
import { stringifyHtml } from '@amf/shared/utils/string';

const SRLOptions: Record<string, any> = {
  lightboxTransitionSpeed: 0.15,
  buttons: {
    showAutoplayButton: false,
    showDownloadButton: false,
    showThumbnailsButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    iconPadding: '8px',
    size: '40px',
  },
  thumbnails: {
    showThumbnails: false,
  },
};

interface GalleryProps {
  blocks: ContentDataBlockImage[];
}

export default function Gallery({ blocks }: GalleryProps) {
  const showCaption =
    blocks.filter(block => stringifyHtml(block.data.caption).length > 0).length > 0;

  return (
    <div
      className={classNames('Content__gallery', {
        'Content__gallery--two': blocks.length <= 2,
      })}
    >
      <SRLWrapper
        options={{
          ...SRLOptions,
          caption: {
            showCaption,
            captionTextTransform: 'uppercase',
          },
        }}
      >
        {blocks.map((block, key) => {
          const caption = stringifyHtml(block.data.caption);
          return (
            <div
              key={key}
              className={classNames('Content__image', {
                'Content__image--withBorder': block.data.withBorder,
                'Content__image--withBackground': block.data.withBackground,
                'Content__image--small': !block.data.stretched,
              })}
            >
              <img src={block.data.file.url} alt={caption} />
              {caption.length > 0 && <span className='Content__imageCaption'>{caption}</span>}
            </div>
          );
        })}
      </SRLWrapper>
    </div>
  );
}
